export interface TncSection {
  title: string;
  intro?: string[];
  items?: string[];
  bullets?: boolean;
  outro?: string[];
}

export const TNC_TITLE = 'SYARAT DAN KETENTUAN RUMAH KEBIJAKSANAAN';

export const TNC_INTRO =
  'Selamat datang di Rumah Kebijaksanaan. Syarat dan Ketentuan ini mengatur penggunaan website dan layanan Rumah Kebijaksanaan. Dengan mengakses website, membuat akun, atau menggunakan layanan kami, Anda dianggap telah membaca dan memahami ketentuan ini.';

export const TNC_CLOSING =
  'Dengan menggunakan Rumah Kebijaksanaan, Anda menyatakan telah membaca dan memahami Syarat dan Ketentuan ini.';

export const TNC_SECTIONS: TncSection[] = [
  {
    title: '1. Ketentuan Umum',
    intro: [
      'Rumah Kebijaksanaan adalah platform yang menyediakan layanan pembelian buku, informasi buku, program afiliasi, serta fitur permintaan dan donasi buku.',
      'Dalam Syarat dan Ketentuan ini, istilah "Pengguna" merujuk pada setiap individu yang mengakses atau menggunakan layanan Rumah Kebijaksanaan. "Kami" merujuk pada pengelola Rumah Kebijaksanaan.',
    ],
  },
  {
    title: '2. Pendaftaran Akun',
    items: [
      'Pengguna harus memberikan informasi yang benar, lengkap, dan terbaru saat melakukan pendaftaran.',
      'Pengguna wajib menggunakan nama pengguna (username) yang sesuai dan tidak melanggar hak pihak lain.',
      'Pengguna wajib menjaga kerahasiaan kata sandi dan bertanggung jawab atas aktivitas yang dilakukan melalui akunnya.',
      'Verifikasi nomor telepon melalui kode OTP diperlukan untuk menyelesaikan proses pendaftaran.',
      'Pengguna tidak diperkenankan membuat akun untuk tujuan penipuan, penyalahgunaan layanan, atau tindakan yang melanggar hukum.',
      'Pengguna wajib segera menghubungi pengelola Rumah Kebijaksanaan apabila mengetahui adanya penggunaan akun tanpa izin.',
    ],
  },
  {
    title: '3. Penggunaan Layanan',
    intro: [
      'Pengguna dapat menggunakan fitur yang tersedia di Rumah Kebijaksanaan sesuai dengan ketentuan masing-masing layanan.',
      'Pengguna dilarang:',
    ],
    bullets: true,
    items: [
      'Memberikan informasi palsu atau menyesatkan.',
      'Mengunggah konten yang melanggar hukum, mengandung ancaman, pelecehan, atau merugikan pihak lain.',
      'Menggunakan layanan untuk penipuan atau aktivitas yang tidak sah.',
      'Mengganggu keamanan, sistem, atau operasional website.',
      'Menyalahgunakan fitur pembelian, afiliasi, donasi, atau permintaan buku.',
    ],
    outro: [
      'Kami berhak membatasi aktivitas yang diduga melanggar ketentuan dan mengambil tindakan yang sesuai berdasarkan tingkat pelanggaran serta peraturan yang berlaku.',
    ],
  },
  {
    title: '4. Pembelian Buku',
    items: [
      'Pengguna dapat memilih buku dan melakukan pemesanan melalui fitur pembelian yang tersedia.',
      'Informasi harga, diskon, ketersediaan stok, dan rincian produk ditampilkan pada halaman produk.',
      'Harga dan ketersediaan produk dapat berubah sewaktu-waktu. Perubahan tidak secara otomatis mengubah pesanan yang telah dikonfirmasi, kecuali diperlukan untuk menangani kesalahan atau kondisi tertentu sesuai ketentuan yang berlaku.',
      'Pesanan diproses setelah persyaratan pembayaran yang berlaku terpenuhi.',
      'Pengguna bertanggung jawab memastikan informasi penerima dan alamat pengiriman sudah benar.',
      'Informasi status pesanan dan pengiriman dapat dilihat melalui akun pengguna apabila fitur tersebut tersedia.',
    ],
    outro: [
      'Ketentuan mengenai pembayaran, pembatalan, pengembalian barang, dan pengembalian dana mengikuti kebijakan terkait yang berlaku di Rumah Kebijaksanaan.',
    ],
  },
  {
    title: '5. Pengembalian Barang dan Dana',
    intro: [
      'Pengguna dapat mengajukan pengembalian barang atau dana sesuai dengan ketentuan yang ditetapkan Rumah Kebijaksanaan.',
    ],
    items: [
      'Pengajuan harus disertai informasi dan bukti yang diminta pada formulir pengajuan.',
      'Pengajuan akan ditinjau oleh pengelola berdasarkan alasan, bukti, dan kondisi barang.',
      'Pengajuan dapat disetujui atau ditolak berdasarkan hasil pemeriksaan dan ketentuan yang berlaku.',
      'Pengguna akan menerima informasi mengenai hasil pengajuan melalui sistem atau saluran komunikasi yang tersedia.',
    ],
    outro: [
      'Pengajuan pengembalian barang dan dana tidak otomatis dianggap disetujui sebelum proses pemeriksaan selesai.',
    ],
  },
  {
    title: '6. Program Afiliasi',
    items: [
      'Pengguna dapat mengikuti program afiliasi apabila memenuhi persyaratan yang ditetapkan.',
      'Pengguna wajib memberikan informasi yang benar saat mendaftar sebagai peserta afiliasi.',
      'Aktivitas promosi harus dilakukan secara jujur dan tidak menyesatkan.',
      'Komisi, perhitungan transaksi, dan mekanisme pembayaran afiliasi mengikuti ketentuan program yang berlaku.',
      'Kami dapat meninjau atau membatasi partisipasi apabila ditemukan indikasi kecurangan, manipulasi transaksi, atau pelanggaran ketentuan program.',
    ],
  },
  {
    title: '7. Fitur Donasi dan Permintaan Buku',
    items: [
      'Pengguna dapat mengirimkan permintaan buku melalui fitur yang tersedia.',
      'Setiap permintaan atau unggahan harus disampaikan secara sopan, relevan, dan tidak melanggar hukum.',
      'Pengajuan permintaan buku tidak menjamin bahwa buku tersebut akan tersedia atau diberikan.',
      'Pengguna dilarang menggunakan fitur ini untuk penipuan, spam, pelecehan, atau penyalahgunaan informasi pribadi.',
      'Kami berhak meninjau, menyembunyikan, atau menghapus unggahan yang melanggar ketentuan.',
    ],
  },
  {
    title: '8. Hak Kekayaan Intelektual',
    intro: [
      'Nama, logo, desain, konten, dan elemen website Rumah Kebijaksanaan dilindungi oleh ketentuan hak kekayaan intelektual yang berlaku, kecuali dinyatakan lain.',
      'Pengguna tidak diperkenankan menyalin, memperbanyak, mendistribusikan, atau menggunakan materi milik Rumah Kebijaksanaan tanpa izin yang diperlukan.',
      'Hak atas buku dan materi milik penerbit, penulis, atau pihak ketiga tetap berada pada pemegang hak masing-masing.',
    ],
  },
  {
    title: '9. Pembatasan dan Penangguhan Akun',
    intro: [
      'Kami dapat membatasi, menangguhkan, atau menonaktifkan akun apabila terdapat pelanggaran terhadap Syarat dan Ketentuan ini, indikasi penyalahgunaan, atau kewajiban hukum yang berlaku.',
      'Sepanjang memungkinkan, pengguna akan diberi informasi mengenai tindakan yang diambil dan cara mengajukan keberatan. Penanganan akun tetap memperhatikan hak pengguna dan peraturan yang berlaku.',
    ],
  },
  {
    title: '10. Perubahan Layanan dan Ketentuan',
    intro: [
      'Kami dapat memperbarui fitur, layanan, dan Syarat dan Ketentuan ini sesuai kebutuhan operasional atau perubahan peraturan.',
      'Perubahan material akan diinformasikan melalui website atau saluran komunikasi yang tersedia. Penggunaan layanan setelah perubahan berlaku tunduk pada ketentuan yang telah diperbarui, dengan tetap memperhatikan persetujuan yang diwajibkan oleh hukum.',
    ],
  },
  {
    title: '11. Hukum yang Berlaku',
    intro: [
      'Syarat dan Ketentuan ini tunduk pada hukum Republik Indonesia. Perselisihan yang timbul akan diselesaikan terlebih dahulu melalui musyawarah. Apabila tidak tercapai kesepakatan, penyelesaian dilakukan sesuai ketentuan hukum yang berlaku.',
    ],
  },
  // {
  //   title: '12. Kontak',
  //   intro: [
  //     'Untuk pertanyaan, keluhan, atau permintaan terkait layanan Rumah Kebijaksanaan, silakan hubungi:',
  //   ],
  //   bullets: true,
  //   items: [
  //     'Pengelola: [Nama Badan Usaha]',
  //     'Email: [Alamat Email Resmi]',
  //     'Alamat: [Alamat Pengelola]',
  //   ],
  // },
];
